import React, { Component } from 'react';
import icones from '../../images/avis';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class AvisMapaLlegenda extends Component {

    renderItemsMetors(idsMeteors, metadadesMeteors) {
        return idsMeteors.map((idMeteor) => {
            const meteor = metadadesMeteors[idMeteor];

            if (!meteor) { return null; }

            return (
                <li key={idMeteor}>
                    <img alt={meteor.nom} src={icones[idMeteor]} />{meteor.nom}
                </li>
            );
        });
    }

    render() {
        const { idsMeteors, metadadesMeteors } = this.props;

        return (
            <div className="avis-mapa-llegenda" >
                <ul>
                    {this.renderItemsMetors(idsMeteors, metadadesMeteors)}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { metadadesMeteors: state.avis.meteors };
};

AvisMapaLlegenda.propTypes = {
    metadadesMeteors: PropTypes.object,
    idsMeteors: PropTypes.array
};

export default connect(mapStateToProps, null)(AvisMapaLlegenda);


// WEBPACK FOOTER //
// ./src/components/avis/avisMapaLlegenda.js